function initTextModule() {
  if ($('.text-module').length == 0) {
    return false;
  }

  $('.text-module').each(function () {
    if (window.innerWidth >= 992) {
      $(this).find('figure').each(function () {
        if ($(this).find('img').hasClass('size-large') || $(this).find('img').hasClass('size-full')) {
          $(this).addClass('full-width');
        }
        const imageWidth = $(this).find('img').width();
        $(this).wrapInner('<div class="figure-wrap"></div>');
        $(this).find('.figure-wrap').css('width', imageWidth);
      })
    }
  });
}

export { initTextModule }


// WEBPACK FOOTER //
// ./scripts/modules/text.js